export const displayTimeToParkContainerSelector = ({displayTimeToParkContainer}) => displayTimeToParkContainer